import { useEffect, useState } from "react";
import { Circle, Tooltip, useMap, useMapEvents } from "react-leaflet";

export const NIGERIA_VIEW = { center: [5.0, 6.0], zoom: 7 };
export const TINCAN_VIEW = { center: [6.4315, 3.3455], zoom: 16 };

export function viewFor(key, ports) {
  if (key === "nigeria") return NIGERIA_VIEW;
  if (key === "tincan") return TINCAN_VIEW;
  const p = ports?.find((x) => x.id === key);
  return p ? { center: [p.lat, p.lon], zoom: p.radius_km > 8 ? 11 : 13 } : NIGERIA_VIEW;
}

export function MapView({ view, nonce }) {
  const map = useMap();
  useEffect(() => { map.flyTo(view.center, view.zoom, { duration: 1.2 }); }, [map, nonce, view.center[0], view.center[1], view.zoom]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

export function PortLayer({ ports, onSelect }) {
  if (!ports?.length) return null;
  return ports.map((p) => (
    <Circle key={p.id} center={[p.lat, p.lon]} radius={p.radius_km * 1000} pathOptions={{ color: p.pilot ? "#F59E0B" : "#38BDF8", weight: 1.2, dashArray: "4 4", fillOpacity: 0.06 }} eventHandlers={{ click: () => onSelect(p.id) }}>
      <Tooltip direction="top" opacity={0.95}><strong>{p.name}</strong><br />{p.kind} · {p.region} · {p.vessels} vessel(s)</Tooltip>
    </Circle>
  ));
}

export function PortList({ ports, atSea, active, onSelect }) {
  if (!ports?.length) return null;
  return (
    <div data-testid="port-list">
      <ul className="max-h-[260px] space-y-0.5 overflow-y-auto text-xs">
        {ports.map((p) => (
          <li key={p.id}>
            <button data-testid={`port-${p.id}`} onClick={() => onSelect(p.id)} className={`flex w-full items-center justify-between rounded px-2 py-1 text-left transition-colors hover:bg-white/5 ${active === p.id ? "bg-lime-500/10 text-lime-200" : "text-slate-200"}`}>
              <span className="truncate">{p.name}<span className="ml-1 text-[10px] text-slate-500">{p.region}</span></span>
              {p.vessels ? <span className="font-mono text-slate-100" title="estimated CO₂ now (ESTIMATE)">{p.vessels}<span className="ml-2 text-[10px] text-amber-300/80">{p.co2_kg_h_est >= 1000 ? `${(p.co2_kg_h_est / 1000).toFixed(1)} t` : `${p.co2_kg_h_est} kg`} CO₂/h*</span></span> : <span className="font-mono text-[10px] text-slate-600" title="The active AIS source has no recent vessels here">no AIS</span>}
            </button>
          </li>
        ))}
      </ul>
      <div className="mt-2 flex justify-between border-t border-[#1E3E30] pt-1.5 font-mono text-[11px] text-slate-400"><span>at sea / offshore</span><span data-testid="port-at-sea">{atSea}</span></div>
      <div className="mt-1 text-[10px] text-slate-500">Indicative port reference circles · not for navigation · *CO₂ per hour is an ESTIMATE</div>
    </div>
  );
}

export function ZoomGate({ min, children }) {
  const map = useMap();
  const [zoom, setZoom] = useState(map.getZoom());
  useMapEvents({ zoomend: () => setZoom(map.getZoom()) });
  return zoom >= min ? children : null;
}
